module.exports = __webpack_public_path__ + "static/media/JSA11_EDITSINGLE.bd01af6d.mp4";